export interface NotificationFilterOption {
  value: string;
  labelKey: string;
  notificationTypes: string[];
  iconType?: string;
}

const commonOptions: NotificationFilterOption[] = [
  { value: 'bigBladder', labelKey: 'almostNotificiation', notificationTypes: ['bigBladder'], iconType: 'bigBladder' },
  { value: 'urinated', labelKey: 'checkNotificiation', notificationTypes: ['urinated'], iconType: 'urinated' },
  { value: 'gotUp', labelKey: 'gotUpNotificiation', notificationTypes: ['gotUp'], iconType: 'gotUp' },
];

const restartOption: NotificationFilterOption = {
  value: 'resetUrine', labelKey: 'measurementRestartNotification', notificationTypes: ['resetUrine'],
};
const removedOption: NotificationFilterOption = {
  value: 'dfreeDeviceRemoved', labelKey: 'detachedSensorNotification', notificationTypes: ['dfreeDeviceRemoved'],
};
const upsideDownOption: NotificationFilterOption = {
  value: 'upsideDown', labelKey: 'sensorUpsideDownNotification', notificationTypes: ['upsideDown'],
};

export const MEDICAL_NOTIFICATION_FILTER_OPTIONS: NotificationFilterOption[] = [
  ...commonOptions,
  restartOption,
  removedOption,
  upsideDownOption,
  { value: 'batteryDead', labelKey: 'lowBatteryNotification', notificationTypes: ['batteryDead'] },
  { value: 'batteryAlert', labelKey: 'deviceAlertNotification', notificationTypes: ['batteryAlert'] },
];

export const PROFESSIONAL_NOTIFICATION_FILTER_OPTIONS: NotificationFilterOption[] = [
  ...commonOptions.map((option) => option.value === 'gotUp'
    ? { ...option, notificationTypes: ['gotUp', 'gasGotUp'] }
    : option),
  { value: 'gasPooped', labelKey: 'odorDetectionNotification', notificationTypes: ['gasPooped'], iconType: 'gasPooped' },
  { value: 'gasPrediction', labelKey: 'estimatedTimeOfDefecationNotification', notificationTypes: ['gasPrediction'], iconType: 'gasPrediction' },
  restartOption,
  upsideDownOption,
  removedOption,
  { value: 'zeroReset', labelKey: '@checkForInsufficientGelOrLooseAttachmentNotification', notificationTypes: ['zeroReset'] },
  { value: 'position', labelKey: '@positionNotification', notificationTypes: ['moveUpperAdvice', 'moveLowerAdvice'] },
  { value: 'connected', labelKey: '@dataCommunicationStartedNotificationUrine', notificationTypes: ['connected'] },
  { value: 'disconnected', labelKey: '@dataCommunicationInterruptedNotificationUrine', notificationTypes: ['disconnected'] },
  { value: 'batteryDead', labelKey: '@lowBatteryNotificationUrine', notificationTypes: ['batteryDead'] },
  { value: 'batteryAlert', labelKey: '@deviceAlertNotificationUrine', notificationTypes: ['batteryAlert'] },
  { value: 'gasConnected', labelKey: '@dataCommunicationStartedNotificationStool', notificationTypes: ['gasConnected'] },
  { value: 'gasDisconnected', labelKey: '@dataCommunicationInterruptedNotificationStool', notificationTypes: ['gasDisconnected'] },
  { value: 'gasBatteryDead', labelKey: '@lowBatteryNotificationStool', notificationTypes: ['gasBatteryDead'] },
  { value: 'gasBatteryAlert', labelKey: '@deviceAlertNotificationStool', notificationTypes: ['gasBatteryAlert'] },
];

export const getNotificationFilterOptions = (medical: boolean) =>
  medical ? MEDICAL_NOTIFICATION_FILTER_OPTIONS : PROFESSIONAL_NOTIFICATION_FILTER_OPTIONS;
